import React, { useState } from "react";
import IntlMessages, { IntlGetText } from "util/IntlMessages";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import InfoCard from "components/InfoCard/index";
import CustomTabs from "./customTabs";

const PatientInfo = (props) => {
  const [open, setOpen] = useState(false);
  const handleRequestClose = () => setOpen(false);

  return (
    <>
      <InfoCard
        data={{
          icon: "book",
          title: IntlGetText("core.data"),
          subTitle: IntlGetText("core.patient"),
          color: "#757575",
        }}
        onClickBox={()=>setOpen(true)}
      />
      <Dialog
        fullWidth={true}
        maxWidth="md"
        open={open}
        disableBackdropClick={true}
        onClose={handleRequestClose}
      >
        <DialogTitle>
          <IntlMessages id="patientInfo.titleDlg" />
        </DialogTitle>
        <DialogContent>
          <CustomTabs {...props}/>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleRequestClose} color="secondary">
            <IntlMessages id="core.close" />
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default PatientInfo;
